import React, { FC, useState } from 'react'
import { isFulfilled } from '@reduxjs/toolkit'
import { FormikHelpers } from 'formik'

import Form from '../../components/Form'
import TextInput from '../../components/UI/Inputs/TextInput'
import CustomButton from '../../components/UI/Buttons/CustomButton'
import ErrorMessage from '../../components/UI/Tooltips/ErrorMessage'
import UploadImage from '../../components/UploadCropImage'

import { useDispatch, useSelector } from '../../store'
import { createAgencyThunk, updateAgencyThunk } from '../../store/agency/thunks'

import { TCreateAgencyFormValues } from '../../models/form'
import { TUpdateAgencyPayload } from '../../store/agency/types'
import { initSubscritionThunk } from '../../store/billing/thunks';

interface CreateAgencyStep1Props {
  goForward: () => void
  inProgress: boolean
}

const CreateAgencyStep1: FC<CreateAgencyStep1Props> = ({ inProgress, ...props }) => {
  const [image, setImage] = useState<any>(null)
  const dispatch = useDispatch()
  const { error, agency } = useSelector((state) => ({
    error: state.agency.error || state.billing.error,
    agency: state.agency.agency
  }))

  const setUpForm = {
    initialValues: agency && agency.name ? { name: agency.name } : { name: '' },
    validation: 'agency',
    onSubmit: async (
      values: TCreateAgencyFormValues,
      actions: FormikHelpers<TCreateAgencyFormValues>
    ) => {
      if (agency && agency.id) {
        const data = new FormData()
        data.append('name', values.name)
        if (image) {
          data.append('image', image)
        }
        data.append('_method', 'PUT')
        const payload: TUpdateAgencyPayload = {
          data,
          agencyId: agency.id
        }
        const updateAgencyResponse = await dispatch(updateAgencyThunk(payload))
        if (isFulfilled(updateAgencyResponse)) props.goForward()
      } else {
        const data = new FormData()
        data.append('name', values.name)
        if (image) {
          data.append('image', image)
        }
        const subscriptionResponse = await dispatch(initSubscritionThunk())
        if (isFulfilled(subscriptionResponse)) {
        const createAgencyResponse = await dispatch(createAgencyThunk(data))
        if (isFulfilled(createAgencyResponse)) props.goForward()
        }
      }
    }
  }

  return (
    <div className='agency-creation-step'>
      <div className='agency-creation-step__title'>Company details</div>
      <div className='agency-creation-step__description'>
        Upload your company’s logo and type the name of your company
      </div>
      <div className='agency-creation-step__upload-logo'>
        {agency && agency.logo_image_link ? (
          <UploadImage
            setImage={setImage}
            uploadedImage={agency.logo_image_link}
            imageBorder='circle'
          />
        ) : (
          <UploadImage setImage={setImage} imageBorder='circle' />
        )}
      </div>
      <Form {...setUpForm}>
        <TextInput label='Company name' name='name' placeholder='Enter company name' />
        <CustomButton inProgress={inProgress} button='primary' size='big' type='submit'>
          Submit
        </CustomButton>
      </Form>
      {error && <ErrorMessage text={error.error.message} />}
    </div>
  )
}

export default CreateAgencyStep1
